import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { MdDeliveryDining, MdOutlineCancel } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiProgress2Fill } from "react-icons/ri";
import { SlCheck } from "react-icons/sl";
import { useSelector } from "react-redux";
import moment from "moment";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import DropdownMenubar from "../../../components/Menubar/DropdownMenubar";
import { Badge } from "primereact/badge";
import OrderApi from "../../../apis/order.apis";
import { toast } from "react-toastify";
import PrintInvoice from "./PrintInvoice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";
import { useFetchAll } from "../../../custom/FetchApiHook";
function OrderDetails({
  deliveryAddress,
  orderDetails,
  orderData,
  getUnitName,
  getPackageName,
  pagination,
  search,
  handleCloseOrderModal,
}) {
  const { theme } = useSelector((state) => state.theme);

  const { fetchAllData } = useFetchAll(() =>
    OrderApi.getAllOrders(pagination ? pagination : {}, search),
  );

  const handleAction = async (data, action) => {
    if (action.vendor_action) {
      const payload = {
        orderId: data._id,
        vendor_action: action.vendor_action,
      };
      try {
        const res = await OrderApi.updateOrders(payload);
        toast.success(`${res?.data?.data}`);
        fetchAllData();
        handleCloseOrderModal();
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div
      className={`mx-auto rounded-lg shadow-md transition-all duration-300 ease-in-out p-2 ${
        theme === "light"
          ? "bg-white text-gray800"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6 border-b border-gray300 pb-4">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium">
              Invoice #{orderData?.order_id} -{" "}
              {moment(deliveryAddress?.createdAt).format("DD MMM YYYY hh:mm A")}
            </p>
            <p>
              Payment status:{" "}
              <span
                className={`text-sm ${
                  orderData?.payment_status === "UNPAID"
                    ? "text-red500"
                    : "text-green500"
                }`}
              >
                {orderData?.payment_status}
              </span>
            </p>

            <p className="text-sm text-gray500">
              Payment type: {orderData?.pay_type}
            </p>
          </div>
          <div className="bg-blue-900 text-white px-4 py-2 rounded-md text-sm text-center shadow">
            <p>{orderData?.delivery_status}</p>
            <p>
              {moment(deliveryAddress?.updatedAt).format("DD MMM YYYY hh:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-gray500 text-xl hover:text-blue-900 transition duration-300">
            {deliveryAddress?.phone_number ?? "N/A"}
          </p>
          <BsTelephone className="text-2xl text-blue-900 hover:text-green700 transition duration-300" />
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl" />
          <p className="">
            {deliveryAddress?.flat_no ?? "N/A"},{" "}
            {deliveryAddress?.landmark ?? "N/A"},
            {deliveryAddress?.street ?? "N/A"},{" "}
            {deliveryAddress?.pin_code ?? "N/A"}
          </p>
        </div>
        {/* <p className="text-gray500 text-sm mt-2">2.90 Km, 8.75 Min</p>
        <p className="text-gray700 mt-3 font-medium">Order for</p> */}
        {/* <p className="text-gray700 mt-4 text-xl hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p> */}
      </div>
      {/* <div
        className={`p-6 rounded-lg shadow-lg max-w-lg mx-auto transition-all duration-300 ${
          theme === "light"
            ? "bg-secondaryColor text-textColorLight"
            : "bg-darkThirsary text-darkSecondary"
        }`}
      ></div> */}
      <hr className="my-4 border-gray300" />
      {orderDetails.map((details, index) => (
        <div
          key={index}
          className="mb-6 p-4 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
        >
          {/* {JSON.stringify(details?.product?.product_details)} */}
          <div className="flex justify-between items-center">
            <div className="w-fit flex justify-center items-center gap-2">
              <div className="overflow-hidden">
                {details?.vendor?.profile_image ? (
                  <LazyLoadImage
                    src={details?.vendor?.profile_image}
                    alt="img"
                    loading="lazy"
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: "1s" },
                    }}
                    className="rounded-full w-4"
                  />
                ) : (
                  <div className="rounded-sm w-5 bg-[#d2d2d2] flex justify-center items-center">
                    <FcShop className="text-[3rem]  text-[#02aabd93]" />
                  </div>
                )}
              </div>
              <h3 className="font-bold text-xl text-gray800 w-full">
                {details?.vendor?.first_name || ""}
              </h3>
            </div>
            <div>
              <GetVendorInfo row={details} handleAction={handleAction} />
            </div>
          </div>

          <hr className="my-4" />
          <div
            className={`grid grid-cols-12 gap-4 p-4 rounded-lg ${
              theme === "light" ? "bg-white" : "bg-gray-900 border-gray-700"
            }`}
          >
            {/* LEFT: Details */}
            <div className="col-span-8 space-y-2">
              <h3
                className={`font-bold text-lg ${theme === "light" ? "text-gray-800" : "text-white"}`}
              >
                {details?.product?.name ?? "Unnamed Product"}
              </h3>

              <p
                className={`text-sm font-semibold ${theme === "light" ? "text-blue-900" : "text-blue-300"}`}
              >
                Quantity: {details?.quantity ?? 0}{" "}
                {getUnitName(details?.product?.unit)}
              </p>

              <p
                className={`text-sm font-semibold ${theme === "light" ? "text-blue-900" : "text-blue-300"}`}
              >
                Packaging: {getPackageName(details?.product?.package_type)}
              </p>

              <p
                className={`text-sm font-semibold ${theme === "light" ? "text-blue-900" : "text-blue-300"}`}
              >
                Price{" "}
                {formattedAmount(
                  +details?.product?.taxData?.grandTotal?.$numberDecimal ||
                    +details?.product?.taxData?.grandTotal,
                )}
              </p>

              <p
                className={`text-sm font-semibold ${theme === "light" ? "text-blue-900" : "text-blue-300"}`}
              >
                Delivery Charge{" "}
                {formattedAmount(
                  Number(details?.delivery_fee?.totalDeliveryFee ?? 0),
                )}
              </p>
            </div>

            {/* RIGHT: Image */}
            <div className="col-span-4 flex justify-end">
              <div className="w-28 h-28 rounded-xl overflow-hidden border bg-gray-100">
                <LazyLoadImage
                  src={details?.product?.primary_image}
                  alt="product"
                  loading="lazy"
                  effect="blur"
                  className="w-full h-full object-fit"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <p className="text-green600 text-lg font-semibold">
              Net Total{" "}
              {formattedAmount(
                (+details?.product?.taxData?.grandTotal?.$numberDecimal ||
                  +details?.product?.taxData?.grandTotal) *
                  +details?.quantity +
                  +details?.delivery_fee?.totalDeliveryFee,
              )}
            </p>
            <OrderStatus row={details} />
          </div>
          <hr className="mt-2 border-gray300" />
          <PrintInvoice
            details={details}
            deliveryDetails={deliveryAddress}
            vendorDetails={details.vendor}
            index={index}
          />
          {/* <Accordion multiple activeIndex={[index]}>
            <AccordionTab header={<p className="text-lg font-bold my-4">Invoice</p>}>
              <TaxData
                key={`${index}t`}
                item={details?.product?.product_details}
              />
              <DeliveryFeeData key={`${index}d`} data={details?.delivery_fee} />
            </AccordionTab>
          </Accordion> */}
        </div>
      ))}
    </div>
  );
}

export default OrderDetails;

const OrderStatus = ({ row }) => {
  let severity;
  if (row.delivery_status === "DELIVERED") {
    severity = "success";
  } else if (row.delivery_status === "WAITING") {
    severity = "warning";
  } else if (row.delivery_status === "ACCEPTED") {
    severity = "success";
  } else if (row.delivery_status === "CANCELLED") {
    severity = "danger";
  }

  return row.delivery_status ? (
    <Badge
      className="w-[9rem]"
      severity={severity}
      value={row.delivery_status}
    />
  ) : null;
};

const DD = ({ MenuItems }) => {
  return (
    <div className="w-[1.5rem] btn pl-2 h-[1.5rem] rounded-sm flex justify-center items-center">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};
const GetVendorInfo = ({ row, handleAction }) => {
  const status = row?.delivery_status;
  switch (status) {
    case "WAITING":
      return (
        <DD
          MenuItems={[
            {
              label: "ACCEPT",
              icon: <SlCheck style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "ACCEPT" });
              },
            },
            {
              label: "REJECT",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "REJECT" });
              },
            },
          ]}
        />
      );
    case "REJECTED":
      return <>Rejected</>;
    case "ACCEPTED":
      return (
        <DD
          MenuItems={[
            {
              label: "ASSIGN",
              icon: <RiProgress2Fill style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "ASSIGN" });
              },
            },
            {
              label: "DELIVERED",
              icon: (
                <IoCheckmarkDoneCircleOutline
                  style={{ color: " rgb(15 61 100)" }}
                />
              ),
              command: () => {
                handleAction &&
                  handleAction(row, { vendor_action: "DELIVERED" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "PREPARED":
      return (
        <DD
          MenuItems={[
            {
              label: "READY",
              icon: (
                <IoCheckmarkDoneCircleOutline
                  style={{ color: " rgb(15 61 100)" }}
                />
              ),
              command: () => {
                handleAction && handleAction(row, { vendor_action: "READY" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "READY":
      return (
        <DD
          MenuItems={[
            {
              label: "ASSIGN",
              icon: <MdDeliveryDining style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "ASSIGN" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "ASSIGNED":
      return (
        <DD
          MenuItems={[
            {
              label: "DELIVERED",
              icon: (
                <IoCheckmarkDoneCircleOutline
                  style={{ color: " rgb(15 61 100)" }}
                />
              ),
              command: () => {
                handleAction &&
                  handleAction(row, { vendor_action: "DELIVERED" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    default:
      return <></>;
  }
};
